import React, {useState} from "react";
import {Slider, Typography} from "@mui/material";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "./ManualScore.css";

const ManualScoreSkills = ({updateScore, cvScore}) => {

    const marks = [
        {
            value: 10,
            label: 'max 10',
        },
    ];

    const [scores, setScores] = useState(cvScore);

    const handleChange = (e) => {
        let {name, value} = e.target;
        setScores((prevScore) => ({
            ...prevScore,
            [name]: value,
        }));
        updateScore("skillsScore", {...scores, [name] : value})
    }

    return (
        <Box className={"scoringBox"} data-testid={"manualScoreBox"}>
            <Grid container padding={2} spacing={2}>
                <Grid item xs={12}>
                    <h3>
                        Skills
                    </h3>
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Skill relevance
                    </Typography>
                    <Slider
                        maxWidth
                        style={{color: "#FF6600"}}
                        min={0}
                        step={1}
                        value={scores?.relevantSkill}
                        name={"relevantSkill"}
                        data-testid={"skillRelevance"}
                        max={10}
                        valueLabelDisplay="auto"
                        marks={marks}
                        onChange={(e) => {handleChange(e)}}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Are the skills current
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        max={10}
                        data-testid={"skillCurrent"}
                        value={scores?.currentSkill}
                        valueLabelDisplay="auto"
                        onChange={(e) => {handleChange(e)}}
                        name={"currentSkill"}
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Appropriate years of experience
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        max={10}
                        onChange={(e) => {handleChange(e)}}
                        valueLabelDisplay="auto"
                        name={"yearsExperience"}
                        value={scores?.yearsExperience}
                        data-testid={"yearsExp"}
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}>
                    <Typography id="non-linear-slider" variant={"caption"} gutterBottom>
                        Are the skills at the required level
                    </Typography>
                    <Slider
                        style={{color: "#FF6600"}}
                        maxWidth
                        min={0}
                        step={1}
                        data-testid={"requiredLevel"}
                        value={scores?.skillLevel}
                        max={10}
                        name={"skillLevel"}
                        valueLabelDisplay="auto"
                        onChange={(e) => {handleChange(e)}}
                        marks={marks}
                        aria-labelledby="non-linear-slider"
                    />
                </Grid>

                <Grid item xs={12}/>
            </Grid>
        </Box>
    )
}
export default ManualScoreSkills;